const url = "/api/v1/cohort";

export interface CohortParticipant {
  currentlyTrying: string[];
  expertise: string[];
  firstName: string;
  goal: string;
  gratefulFor: string;
  hasVisibleProfile: boolean;
  id: string;
  lastName: string;
  location: string;
  moreAboutMe: string;
  partnerName: string;
  partnerType: string;
  previouslyTried: string[];
  profilePicture: string;
  tripTomorrow: string;
  tryingSince: string;
  typicalWeek: string;
  type: string;
  whoIAm: string;
}

export interface CohortIndexResponse {
  id: string;
  participants: CohortParticipant[];
  whatsAppLink: string;
}

export const cohortIndexQuery = () => url;
